import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';

const Submit = ({
  className,
  content,
  disabled,
  hasLongText,
  onClick,
}) => {

  const allClassNames = className ? className.split(' ') : [];

  if (hasLongText) {
    allClassNames.push('booking-overview__confirm--long-text');
  }

  return (
    <button
      className={allClassNames.join(' ')}
      disabled={disabled}
      onClick={() => onClick()}
      type="submit"
    >
      <Translate content={content} />
    </button>
  );
};

Submit.PropTypes = {
  className:PropTypes.string,
  content:PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hasLongText:PropTypes.bool,
  onClick:PropTypes.func.isRequired,
};

export default Submit;
